// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__tT18c","checkboxCol":"Table_checkboxCol__3eFll","emailCol":"Table_emailCol__1dt64","actionCol":"Table_actionCol__LlcNF"};